export enum TicketStatus {
	New = 'New',
	Open = 'Open',
	Pending = 'Pending',
	Closed = 'Closed',
	Spam = 'Spam',
}

export enum TicketPriority {
	Low = 'Low',
	Normal = 'Normal',
	High = 'High',
	Urgent = 'Urgent',
}

export enum TicketSource {
	Inbound = 'Inbound',
	Manual = 'Manual',
	Migrated = 'Migrated',
}

export enum ThreadType {
	CustomerMessage = 'CustomerMessage',
	AgentReply = 'AgentReply',
	Note = 'Note',
	AiDraft = 'AiDraft',
	Forward = 'Forward',
}

/**
 * Structured ticket activity events. These replace the former `ThreadType.System`
 * pseudo-threads: the API now records audit-style activity in `support.ticketEvents`
 * and exposes them via `GET support/tickets/{id}/events`.
 */
export enum SupportEventType {
	Assigned = 'Assigned',
	Unassigned = 'Unassigned',
	StatusChanged = 'StatusChanged',
	PriorityChanged = 'PriorityChanged',
	CategoryChanged = 'CategoryChanged',
	CustomerChanged = 'CustomerChanged',
	TicketLinked = 'TicketLinked',
	TicketUnlinked = 'TicketUnlinked',
	Merged = 'Merged',
	GitHubIssueLinked = 'GitHubIssueLinked',
	GitHubIssueUnlinked = 'GitHubIssueUnlinked',
	GitHubIssueCreated = 'GitHubIssueCreated',
	GitHubIssueUpdated = 'GitHubIssueUpdated',
	GitHubIssueSynced = 'GitHubIssueSynced',
	Forwarded = 'Forwarded',
	Rated = 'Rated',
}

export enum DeliveryStatus {
	Delivered = 'Delivered',
	Bounced = 'Bounced',
	Dropped = 'Dropped',
}

export enum ThreadStatus {
	Draft = 'Draft',
	Sent = 'Sent',
	Received = 'Received',
	Failed = 'Failed',
	Accepted = 'Accepted',
	Rejected = 'Rejected',
}

export enum AssignmentMethod {
	Balanced = 'Balanced',
	RoundRobin = 'RoundRobin',
}

export enum AgentRole {
	Support = 'Support',
	Admin = 'Admin',
}
